export const removeStaleSilencedCases = ({
  silencedCaseTimeToStale,
  useMainStore,
}) => {
  const mainStore = useMainStore();

  const caseIsStaleIfBefore = Date.now() - silencedCaseTimeToStale * 1000;

  Object.keys(mainStore.caseTracker).forEach((key) => {
    if (mainStore.caseTracker[key].createdAt < caseIsStaleIfBefore) {
      delete mainStore.caseTracker[key];
    }
  });
};
